// Pickup visual polish — pure helpers the renderer uses to make loot read as desirable: a gentle
// brightness "glint" that twinkles each pickup, and a per-kind ground-glow weight so valuables
// (chests, vendors, big gems) sit in a beacon of light. Render-only — no sim/determinism impact.

/** Brightness multiplier that twinkles a pickup over time (bounded ~0.78..1.22). */
export function pickupGlint(time: number, seed: number): number {
  return 1 + 0.22 * Math.sin(time * 4 + seed)
}

/**
 * How strong a ground-glow a pickup deserves, 0 (none) .. 1 (beacon). Valuables glow brightly,
 * small XP gems not at all, so the eye is drawn to what matters in a dense field.
 */
export function pickupGlow(kind: string, tier = 1): number {
  switch (kind) {
    case 'chest':
    case 'vendor':
      return 1
    case 'heal':
      return 0.6
    case 'gold':
      return 0.35
    case 'xp':
      return tier >= 3 ? 0.7 : tier === 2 ? 0.4 : 0
    default:
      return 0
  }
}
